export default "__VITE_ASSET__BBrrqDvd__"